import React, {FC, useEffect} from 'react';
import {useNavigate} from 'react-router';
import {useAuth} from 'global/auth/use-auth';
import {Loading} from 'common/loading';
import {RoutesSettings} from 'config/routes';

export const AuthRoute: FC<{ redirectTo?: string }> = ({redirectTo = RoutesSettings.home}) => {
    const {user} = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (user) {
            navigate(redirectTo, {replace: true});
        }
    }, [user, redirectTo, navigate]);

    return <Loading/>;
};
